(function(){
  function openFinanceCard(){
    document.querySelectorAll('[data-lbx-finance-card]').forEach(function(card){
      var controls = card.querySelector('[data-lbx-finance-controls]');
      var toggle = card.querySelector('[data-lbx-finance-toggle]');
      if(controls){ controls.hidden = false; controls.removeAttribute('hidden'); }
      if(toggle){ toggle.setAttribute('aria-expanded','true'); }
    });
  }

  function enableDesktopFilterAutosubmit(){
    if(window.innerWidth <= 1024) return;
    document.querySelectorAll('.lbxcat-sidebar form input[type="checkbox"]').forEach(function(input){
      if(input.dataset.lbx81Bound === 'true') return;
      input.dataset.lbx81Bound = 'true';
      input.addEventListener('change', function(){
        var form = input.form || input.closest('form');
        if(!form) return;
        if(typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      });
    });
    document.querySelectorAll('.lbxcat-sidebar label').forEach(function(label){
      if(label.dataset.lbx81ClickBound === 'true') return;
      label.dataset.lbx81ClickBound = 'true';
      label.addEventListener('click', function(event){
        var input = label.querySelector('input[type="checkbox"]');
        if(!input || event.target === input) return;
        event.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function run(){
    openFinanceCard();
    enableDesktopFilterAutosubmit();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
  window.addEventListener('resize', function(){ setTimeout(enableDesktopFilterAutosubmit, 80); }, { passive:true });
  document.addEventListener('shopify:section:load', run);
})();
